import axios from "axios";
import config from "./config"

//注册实例
const instance = axios.create({
    baseURL: config.baseUrl,
    timeout: config.timeout
});

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    let result = response.data
    return result;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default instance